export default __webpack_public_path__ + "static/media/jaguar.e0623306.png";